import Helper from '@ember/component/helper';

export default class extends Helper {
  compute() {
    window.addEventListener('beforeunload', beforeUnloadHandler);

    return null;
  }
  willDestroy() {
    // removeevent
    super.willDestroy(...arguments);
    window.removeEventListener('beforeunload', beforeUnloadHandler);
  }
}

const beforeUnloadHandler = (event) => {
  // Recommended
  event.preventDefault();

  // Included for legacy support, e.g. Chrome/Edge < 119
  event.returnValue = true;
};
